export const EXHIBITION_SCHEDULE_DEFAULT_LOCALE = 'en'

export const EXHIBITION_SCHEDULE_MESSAGES = {
  en: {
    exhibitionComingSoon: {
      title: 'Exhibition Information',
      description: 'Stay tuned for our upcoming exhibitions.'
    },
    exhibitionPoster: {
      title: 'IWF Shenzhen 2026 Exhibition Poster',
      imageAlt: 'IWF Shenzhen 2026 exhibition poster',
      close: 'Close IWF Shenzhen 2026 exhibition poster'
    },
    common: {
      ok: 'OK'
    }
  },
  zh: {
    exhibitionComingSoon: {
      title: '展会信息',
      description: '敬请期待我们的展会信息。'
    },
    exhibitionPoster: {
      title: 'IWF 深圳国际健身展 2026 展会海报',
      imageAlt: 'IWF 深圳国际健身展 2026 展会海报',
      close: '关闭 IWF 深圳国际健身展 2026 展会海报'
    },
    common: {
      ok: '确定'
    }
  }
}

export function normalizeExhibitionScheduleLocale(locale) {
  return typeof locale === 'string' && locale.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}
